import { render, staticRenderFns } from "./offers.vue?vue&type=template&id=b5180194&"
import script from "./offers.vue?vue&type=script&lang=js&"
export * from "./offers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5180194')) {
      api.createRecord('b5180194', component.options)
    } else {
      api.reload('b5180194', component.options)
    }
    module.hot.accept("./offers.vue?vue&type=template&id=b5180194&", function () {
      api.rerender('b5180194', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UJ7l0j7NZryz/JS/comp/offers.vue"
export default component.exports